import { useCallback, useEffect, useState } from 'react'
import { api } from '../lib/api.js'
import { dataHora } from '../lib/formato.js'

const PAPEIS = ['leitor', 'editor', 'publicador', 'admin']

/** Visivel so para quem e admin em algum agente. */
export function Admin({ agentesDoUsuario, usuario }) {
  const [usuarios, setUsuarios] = useState([])
  const [locks, setLocks] = useState({})
  const [novo, setNovo] = useState({ email: '', agente: agentesDoUsuario[0]?.agente ?? '', papel: 'leitor' })
  const [erro, setErro] = useState(null)
  const [aviso, setAviso] = useState(null)
  const [ocupado, setOcupado] = useState(false)

  const agentesAdministraveis = agentesDoUsuario.filter((a) => a.papel === 'admin').map((a) => a.agente)

  const carregar = useCallback(async () => {
    setErro(null)
    try {
      const { usuarios: lista } = await api.get('/admin/usuarios')
      setUsuarios(lista)

      const estados = await Promise.all(
        agentesAdministraveis.map(async (agente) => [agente, (await api.get(`/agentes/${agente}/rascunho`)).lock]),
      )
      setLocks(Object.fromEntries(estados))
    } catch (falha) {
      setErro(falha.message)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentesAdministraveis.join(',')])

  useEffect(() => {
    carregar()
  }, [carregar])

  async function executar(acao, mensagemDeSucesso) {
    setOcupado(true)
    setErro(null)
    setAviso(null)
    try {
      await acao()
      await carregar()
      setAviso(mensagemDeSucesso)
    } catch (falha) {
      setErro(falha.message)
    } finally {
      setOcupado(false)
    }
  }

  return (
    <section className="admin">
      {erro && <p className="alerta alerta--falha">{erro}</p>}
      {aviso && <p className="alerta alerta--ok">{aviso}</p>}

      <div className="cartao">
        <h2>Bloqueios de edição</h2>
        <p className="ajuda">
          Liberar à força tira a edição de quem está com ela. Use quando alguém fechou a aba e o bloqueio ainda não
          expirou.
        </p>
        <table className="tabela">
          <thead>
            <tr>
              <th>Agente</th>
              <th>Em edição por</th>
              <th>Expira</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {agentesAdministraveis.map((agente) => (
              <tr key={agente}>
                <td>{agente}</td>
                <td>{locks[agente]?.detentor ?? <span className="ajuda">livre</span>}</td>
                <td>{locks[agente] ? dataHora(locks[agente].expiraEm) : '—'}</td>
                <td>
                  <button
                    className="botao botao--pequeno botao--perigo"
                    disabled={!locks[agente] || ocupado}
                    onClick={() =>
                      executar(() => api.del(`/agentes/${agente}/lock`), `Bloqueio de "${agente}" liberado.`)
                    }
                  >
                    forçar liberação
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="cartao">
        <h2>Permissões</h2>
        <form
          className="admin__form"
          onSubmit={(evento) => {
            evento.preventDefault()
            executar(
              () => api.put('/admin/usuarios', { ...novo, email: novo.email.trim().toLowerCase() }),
              `${novo.email} agora é ${novo.papel} em "${novo.agente}".`,
            )
          }}
        >
          <label className="campo campo--inline">
            <span>E-mail</span>
            <input
              type="email"
              value={novo.email}
              onChange={(e) => setNovo({ ...novo, email: e.target.value })}
              required
            />
          </label>
          <label className="campo campo--inline">
            <span>Agente</span>
            <select value={novo.agente} onChange={(e) => setNovo({ ...novo, agente: e.target.value })}>
              {agentesAdministraveis.map((agente) => (
                <option key={agente}>{agente}</option>
              ))}
            </select>
          </label>
          <label className="campo campo--inline">
            <span>Papel</span>
            <select value={novo.papel} onChange={(e) => setNovo({ ...novo, papel: e.target.value })}>
              {PAPEIS.map((papel) => (
                <option key={papel}>{papel}</option>
              ))}
            </select>
          </label>
          <button className="botao botao--primario" disabled={ocupado || !novo.email.trim()}>
            Salvar permissão
          </button>
        </form>

        <table className="tabela">
          <thead>
            <tr>
              <th>E-mail</th>
              <th>Agente</th>
              <th>Papel</th>
              <th>Desde</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {usuarios.map((u) => (
              <tr key={`${u.email}-${u.agente}`}>
                <td>
                  {u.email} {u.email === usuario.email && <span className="etiqueta">você</span>}
                </td>
                <td>{u.agente}</td>
                <td>
                  <span className={`etiqueta ${u.papel === 'admin' ? 'etiqueta--destaque' : ''}`}>{u.papel}</span>
                </td>
                <td>{dataHora(u.criado_em)}</td>
                <td>
                  <button
                    className="botao botao--pequeno botao--perigo"
                    disabled={ocupado || !agentesAdministraveis.includes(u.agente)}
                    onClick={() =>
                      executar(
                        () =>
                          api.del(
                            `/admin/usuarios?email=${encodeURIComponent(u.email)}&agente=${encodeURIComponent(u.agente)}`,
                          ),
                        `Permissão de ${u.email} em "${u.agente}" removida.`,
                      )
                    }
                  >
                    remover
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
